//130354281703477990271793697827
theme.library = 130354281703477990271793697827;
theme.crr_library = localStorage.getItem('library') || '[]';
theme.psjson_lib = new Array;
theme.strings = {
  inStock: "In stock",
  outOfStock: "Out Of Stock",
  soldOut: "Sold out",
  qtyLabel: "Qty",
  addToCart: "Add to cart",
  addedToCart: "Has in cart",
  contact: "Contact",
  remove: "Remove",
  empty: "Your bag is currently empty.",
  cartItem: "You have \u003cspan class='text-bold'\u003e(1 item)\u003c\/span\u003e in your bag",
  cartItems: "You have \u003cspan class='text-bold'\u003e(2 items)\u003c\/span\u003e in your bag",
  cartItemText: "item",
  cartItemsText: "items",
  noimage: "\/\/www.rockscs.com\/cdn\/shop\/t\/44\/assets\/noimage.gif?v=15690",
  cdday: "Days",
  cdhrs: "Hours",
  cdmin: "Minutes",
  cdsecs: "Seconds",
  nll_error_mesenger: "Could not connect to the registration server. Please try again later.",
  nll_success_mesenger: "THANK YOU FOR SUBSCRIBING!\u003c\/br\u003eUse the \u003cspan class=\"code\"\u003e\u003c\/span\u003e code to get a discount on the first purchase.",
  aspect_ratio: "8/5",
  search_dropdown_pages: "Pages",
  search_dropdown_articles: "From the Molla",
  search_dropdown_no_results: "Your search did not yield any results.",
  flt_range: "Range"
};
theme.productStrings = {
  sizeGuide: "Size guide",
  addToCart: "Add to cart",
  preOrder: "Pre order",
  selectOption: "Select options",
  soldOut: "Sold out",
  inStock: "In stock",
  outOfStock: "Out Of Stock",
  unavailable: "Unavailable",
  onlyLeft: "Only \u003cspan\u003e1\u003c\/span\u003e left",
  onSale: "Sale",
  stockMessage: ["Hurry! Only "," left in stock."],
  label_select: "Select a ",
  viewMoreVariants: "More",
  addToWishlist: "Add to Wishlist",
  viewWishlist: "View my Wishlist"
};
theme.function = {
  multiCurrency: false,
  typeCurrency: "customize",
  autoCurrency: false,
  searchAjax: true,
  searchByCollection: true,
  searchAjaxTypes: "product,page,article",
  vrsgallery: false,
  quickshop: "true",
  quickview: false,
  use_thumb_hidden_on_mb: true,
  productImgType: "normal",
  productOptionStyle: [{'name': "Color",'style': "combobox",'color_watched': true,'op_attach': false,'op_pre_select': false},{'name': "Size",'style': "combobox",'color_watched': false,'op_attach': true,'op_pre_select': false},{'name': "",'style': "combobox",'color_watched': false,'op_attach': false,'op_pre_select': false},{'name': "",'style': "combobox",'color_watched': false,'op_attach': false,'op_pre_select': false},{'name': "",'style': "combobox",'color_watched': false,'op_attach': false,'op_pre_select': false}],
  productGridOptionStyle: [{'name': "Color",'style': "circle _small",'color_watched': true, 'sw_style': "color"},{'name': "Size",'style': "list list_1",'color_watched': false, 'sw_style': "color"},{'name': "",'style': "list list_1",'color_watched': false, 'sw_style': "color"},{'name': "",'style': "list list_1",'color_watched': false, 'sw_style': "color"},{'name': "",'style': "list list_1",'color_watched': false, 'sw_style': "color"}],
  photoZoom: true,
  nll_ajax: false,
  type_ajax_cart: "none",
  ajax_cart_page: false,
  sticky_icon_cart: null,
  textInListShipping: " on order over ",
  textInListShippingMax: " on order under ",
  product_delivery: {
    offSaturday: true,
    offSunday: true,
    offDays: ["23\/12\/****","24\/12\/****","01\/01\/****"],
    fromDate: 10,
    toDate: 15 
  },
  countdown_timezone: false,
  timezone: 'EST',
  variantsLoad: false
};
theme.compare = {
  remove: "Remove"
};
theme.gadget = {
  cookies_infor: false,
  newsletter_popup: false,
  shipTo: false
};
theme.suggest = {
  enable: false, 
  collection_opj: null,
  delay_time: 7000,
  show_time: 7600,
  use_fake_location: true,
  arr_fake_location: ["Melbourne, Australia","Washington","Nevada"]
};

theme.extensions = {
  ktjs_product_sg: '//www.rockscs.com/cdn/shop/t/44/assets/ktjs_product_sg.min.js?v=36205597685854357351793697776',
  ktjs_flts_or: false
}

const firstLink = document.getElementsByTagName("link")[0];
const headDocument = document.head;
const bodyDocument = document.body;

if (theme.crr_library.length == 0) {
  localStorage.setItem('library','[]');
}

window._handleize = function(str){
  str = (str+'').toLowerCase();
  return str=str.replace(/'|"|\(|\)|\[|\]/g,"").replace(/[\s\x21-\x2f\x3a-\x40\x7b-\x7f^`\\[\]]+/g,"-").replace(/\W+/g,"-").replace(/^-+|-+$/g,"")
}
window._snakeCase = function(str){
  str = (str+'').toLowerCase();
  return str=str.replace(/'|"|\(|\)|\[|\]/g,"").replace(/[\s\x21-\x2f\x3a-\x40\x7b-\x7f^`\\[\]]+/g,"_").replace(/\W+/g,"_").replace(/^-+|-+$/g,"")
}
$.getScriptCached = function(url, callback) {return $.ajax({url: url,dataType: "script",cache: true}).done(callback)};
"undefined" == typeof KT && (KT = {});
KT.checkVersion = function(name_item){
  name_item = name_item.split('/')[name_item.split('/').length - 1];
  var version = false;
  if(!localStorage.getItem(name_item)){
    version = true; 
  }
  var libs_ver = JSON.parse(theme.crr_library);
  if (libs_ver.length && libs_ver.findIndex(function(obj){ return obj.name == name_item}) !== -1) { 
    var objIndex = libs_ver.findIndex(function(obj){ return obj.name == name_item});
    if (parseFloat(libs_ver[objIndex].ver) !== theme.library) {
      libs_ver[objIndex].ver = theme.library;
      localStorage.setItem('library',JSON.stringify(libs_ver));
      version = true;
    }
  } else if(libs_ver.findIndex(function(obj){ return obj.name == name_item}) === -1){
    version = true;
  }
  return version; 
}
KT.pushVersion = function(name_item){
  var libs_ver = JSON.parse(theme.crr_library);
  if (libs_ver.length && libs_ver.findIndex(function(obj){ return obj.name == name_item}) !== -1) { 
    var objIndex = libs_ver.findIndex(function(obj){ return obj.name == name_item});
    if (parseFloat(libs_ver[objIndex].ver) !== theme.library) {
      libs_ver[objIndex].ver = theme.library;
      localStorage.setItem('library',JSON.stringify(libs_ver));
    }
  }
  else {
    var obj = {
      name : name_item,
      ver : theme.library
    }
    libs_ver.push(obj);
    localStorage.setItem('library',JSON.stringify(libs_ver));
  }
  theme.crr_library = localStorage.getItem('library') || '[]';
}
KT.loadScript = function(id, callback) {
  let css_url = "";
  let js_url = "";
  let done = false;
  if($('#'+id).length || $('#'+id).length){
    checkExists(id, js_url)
  }
  else {
    if(id == 'magnific-popup' && $('#magnific-popup-css').length <= 0){
      css_url = "//www.rockscs.com/cdn/shop/t/44/assets/magnific-popup.min.css?v=8839934251120211981793697777";
      js_url = "//www.rockscs.com/cdn/shop/t/44/assets/jquery.magnific-popup.min.js?v=184369421263510081681793697770";
    }
    else if(id == 'threesixty' && $('#threesixty-css').length <= 0){
      css_url = "//www.rockscs.com/cdn/shop/t/44/assets/threesixty.min.css?v=87491138002852594671793697828";
      js_url = "//www.rockscs.com/cdn/shop/t/44/assets/threesixty.min.js?v=128470061555666291351793697829";
    }
    else if(id == 'photo-swipe' && $('#photo-swipe-css').length <= 0){
      css_url = "//www.rockscs.com/cdn/shop/t/44/assets/photoswipe-ui.min.css?v=50182594455179234001793697795";
      js_url = "//www.rockscs.com/cdn/shop/t/44/assets/photoswipe-ui.min.js?v=25365026511866153621793697796";
    }
    else if(id == 'YTPlayer'){
      css_url = "//www.rockscs.com/cdn/shop/t/44/assets/jquery.mb.YTPlayer.min.css?v=119550751124163094881793697771";
      js_url = "//www.rockscs.com/cdn/shop/t/44/assets/jquery.mb.YTPlayer.min.js?v=58168430563119694231793697771";
    }
    else if(id == 'swiper'){ 
      js_url = "//www.rockscs.com/cdn/shop/t/44/assets/swiper.min.js?v=87601735497094018201793697819";
    }
    else if(id == 'pjax'){
      js_url = "//www.rockscs.com/cdn/shop/t/44/assets/jquery.pjax.min.js?v=96510263879411166301793697772";
    }
    else if(id == 'imagesloaded'){
      js_url = "//www.rockscs.com/cdn/shop/t/44/assets/imagesloaded.pkgd.min.js?v=147859183389955144291793697763";
    }
    else if(id == 'isotope'){
      js_url = "//www.rockscs.com/cdn/shop/t/44/assets/isotope-plus.pkgd.min.js?v=178738151178419850551793697765";
    }
    else if(id == 'instafeed'){
      js_url = "//www.rockscs.com/cdn/shop/t/44/assets/instafeed.min.js?v=120817697245968785561793697764";
    }
    else if(id == 'countdown'){
      js_url = "//www.rockscs.com/cdn/shop/t/44/assets/jquery.countdown.min.js?v=116994322243221080931793697767";
    }
    else if(id == 'countto'){
      js_url = "//www.rockscs.com/cdn/shop/t/44/assets/jquery.countTo.min.js?v=145349820381598039701793697767";
    }
    else if(id == 'moment'){
      js_url = "//www.rockscs.com/cdn/shop/t/44/assets/moment.min.js?v=96302747854271246571793697781";
    }
    else if(id == 'moment-zone'){
      js_url = "//www.rockscs.com/cdn/shop/t/44/assets/moment-timezone-with-data.min.js?v=28936048893783064501793697780";
    }
    else if(id == 'momentlocale'){
      if (shopLocale === 'en') {handleLoad(); return}
      js_url = "//cdnjs.cloudflare.com/ajax/libs/moment.js/2.24.0/locale/"+shopLocale+".js";
    }
    else if(id == 'zoom'){
      js_url = "//www.rockscs.com/cdn/shop/t/44/assets/jquery.zoom.min.js?v=127655014540499679121793697773";
    }
    else if(id == 'parallax'){
      js_url = "//www.rockscs.com/cdn/shop/t/44/assets/jquery.parallax_mousemove.js?v=49881708927219663041793697771";
    }
    else if(id == 'tippy'){
      js_url = "//www.rockscs.com/cdn/shop/t/44/assets/tippy-bundle.iife.min.js?v=133821393238358783871793697829";
    }
    else if(id == 'color_sw'){
      css_url = "//www.rockscs.com/cdn/shop/t/44/assets/swatch-color.css?v=114997909792873708431793697803";
    }
    else if(id == 'animate'){
      css_url = "//www.rockscs.com/cdn/shop/t/44/assets/animate.min.css?v=20349278028107590831793697756";
    }
    else if(id == 'molla_icon'){
      css_url = "//www.rockscs.com/cdn/shop/t/44/assets/molla-icon.css?v=97651397459369222751793697778";
    }
    else if(id == 'molla_font'){
      css_url = "//www.rockscs.com/cdn/shop/t/44/assets/theme.font.css?v=17433048251075783761793697892";
    }
    else if(id == 'google_f'){
      css_url = theme.link_google_f;
    }
    else if(id == 'adminThemeCss'){
      css_url = "//www.rockscs.com/cdn/shop/t/44/assets/adminThemeTool.scss.css?v=15690";
    }
    else if(id == 'shopify-currency'){
      js_url = "//cdn.shopify.com/s/javascripts/currencies.js";
    }
    else if(id == 'shipping'){
      js_url = "//www.rockscs.com/cdn/shop/t/44/assets/jquery.currency-shipping.min.js?v=77586439398839307371793697769";
    }
    else if(id == 'plyr'){
      css_url = "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.1/shopify-plyr.css";
      js_url = "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.en.js";
    }
    else if(id == 'shopify-xr'){
      js_url = "//cdn.shopify.com/shopifycloud/shopify-xr-js/v1.0/shopify-xr.en.js";
    }
    else if(id == 'model-viewer-ui'){
      css_url = "//cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css";
      js_url = "//cdn.shopify.com/shopifycloud/model-viewer-ui/v1.0/model-viewer-ui.en.js";
    }
    else if(id == 'theme-alert'){
      js_url = "//www.rockscs.com/cdn/shop/t/44/assets/theme-alert.js?v=28077311757223122841793697892";
    }
    done = false;
    ajaxLoad(id, css_url, js_url);
  }
  function ajaxLoad(name, css_url, js_url){
    if(css_url !== ''){
      var scr_css = document.createElement('link');
      scr_css.type = 'text/css';
      scr_css.rel = "stylesheet";
      scr_css.cache = true;
      scr_css.id = name+'-css';
      scr_css.href = css_url;
      scr_css.onerror = function() {
        alert("Error loading css " + this.href);
      };
      headDocument.insertBefore(scr_css, firstLink);
    }
    if(js_url !== ''){
      var scr_js = document.createElement('script');
      scr_js.type = 'text/javascript';
      scr_js.cache = true;
      scr_js.async = true;
      scr_js.src = js_url;
      scr_js.id = name;
      scr_js.onload = checkExists(name, js_url);
      scr_js.onerror = function() {
        alert("Error loading js " + this.src);
      };
      bodyDocument.appendChild(scr_js);
    }
  }
  function checkExists(id, js_url){
    var callbackTimer = setInterval(function() {
      if (id == 'swiper' && typeof Swiper === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'owl-carousel' && typeof $.fn.owlCarousel === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'slick-slide' && typeof $.fn.slick === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'moment' && typeof moment === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'moment-zone' && typeof moment.tz === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }      
      if (id == 'magnific-popup' && typeof $.fn.magnificPopup === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'imagesloaded' && typeof $.fn.imagesLoaded === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'isotope' && typeof $.fn.isotope === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'YTPlayer' && typeof jQuery.fn.YTPlayer === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'parallax' && typeof $.fn.mouseMove === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'countdown' && typeof $.fn.countdown === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'countto' && typeof $.fn.countTo === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'magnific-popup' && typeof $.fn.magnificPopup == 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'instafeed' && typeof Instafeed == 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'momentlocale' && moment.locale() == shopLocale){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'zoom' && typeof $.fn.zoom == 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'pjax' && typeof $.fn.pjax == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'photo-swipe' && typeof PhotoSwipe == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'threesixty' && typeof $.fn.ThreeSixty == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'tippy' && typeof tippy == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'shipping' && typeof Kt_currency.convertAll == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'shopify-currency' && typeof Currency !== "undefined") {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'plyr' && typeof Shopify.Plyr == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'shopify-xr' && typeof ShopifyXR !== 'undefined') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'model-viewer-ui' && typeof Shopify.ModelViewerUI == 'function' ) {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'theme-alert' && typeof KT_Alert !== "undefined" ) {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
    }, 100);
  }
  function handleLoad() {
    if (!done) {
      done = true;
      // console.log(js_url)
      callback(js_url, "ok");
    }
  }
}